import { IEventMessage } from "./eventMessage";
import { Base } from "ui/Scripts/source/framework/base";

export interface ISaveEventMessage {
    id: string;
    text: string;
    modifyDate: number;
}

export class SaveEventMessage implements ISaveEventMessage {
    id: string;
    text: string;
    modifyDate: number;

    constructor();
    constructor(obj: IEventMessage);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.text = obj && obj.text || "";
        this.modifyDate = obj && obj.modifyDate || 0;
    }

    static createSaveEventMessage(text: string): SaveEventMessage {
        const saveEventMessage = new SaveEventMessage();
        saveEventMessage.id = Base.getGuid();
        saveEventMessage.modifyDate = new Date().getTime();
        saveEventMessage.text = text;
        return saveEventMessage;
    }
}